<template>
  <div id="app">
      <b-loading  :active.sync="isFullScreenSearching" ></b-loading>
        <Header v-if="user_id"/>
        <router-view></router-view>
  </div>
</template>

<script>

import axios from "axios"
import Header from './components/Header'
import {mapActions, mapState } from "vuex";
import { checkAccessTokenWithFpValid ,getBaseURLforSocketIo ,getBaseURLforBackEnd , getConfigAxios , getBaseURLAvartar , removeLocalStorage /*, getUserIDfromLocalStorage*/} from '@/utils.js'
import io from 'socket.io-client'



export default {
    /* eslint-disable no-console */
  name: 'app',
  components: {
    Header
  },
   mounted() {
      // console.log('App mount')

   },
    computed:{
        ...mapState({
            user_id : state => state.master_data.user_id ,
            userIsAdmin: state => state.master_data.userIsAdmin ,
            userCustomizeCBCTbl : state => state.master_data.userCustomizeCBCTbl,
            unitCBC : state => state.master_data.unitCBC ,
            fingerPrint : state => state.master_data.fingerPrint,
            access_token: state => state.master_data.access_token,
        }),

    },
   methods:{
    
        ...mapActions({
            fetchUserCustomizeCBCTbl : 'master_data/fetchUserCustomizeCBCTbl',
            fetchUnitCBC : 'master_data/fetchUnitCBC',
            // fetchProvince : 'master_data/fetchProvince',
            fetchFingerprint : 'master_data/fetchFingerprint' ,
            produceUserID : 'master_data/produceUserID' ,
            produceUserAvartar : 'master_data/produceUserAvartar' ,
            fetchClientIP: 'master_data/fetchClientIP',
            produceUserIsAdmin: 'master_data/produceUserIsAdmin',
            fetchDocKind : 'master_data/fetchDocKind' ,
            fetchOrdersList : 'orders/fetchOrdersList',


        }),
        handler: function handler() {
            removeLocalStorage()
        },


    },
   created() {



          // if(this.$router.history.current.path !=='temptest'){
          //     window.addEventListener('beforeunload', this.handler)
          // }


          window.addEventListener('beforeunload', this.handler)


          this.fetchFingerprint()
              .then((res) => {
                  if (!vm.user_id) {
                  // if (!localStorage.getItem("user_id")) {
                      this.$router.push('/login')
                          .catch(()=>{});
                      this.isFullScreenSearching = false


                  } else if (!localStorage.getItem("access_token")) {
                      this.$router.push('/login')
                          .catch(()=>{});
                      this.isFullScreenSearching = false


                  } else {
                      checkAccessTokenWithFpValid(res)
                          .then((res) => {
                              if (!res) {
                                  this.$router.push('/login')
                                      .catch(()=>{});

                                  this.isFullScreenSearching = false
                                  removeLocalStorage()
                              }
                          })
                          .catch(() => {
                              this.$router.push('/login')
                                  .catch(()=>{});

                              this.isFullScreenSearching = false
                              removeLocalStorage()
                          })

                  }
              })
              .finally(() => {
                  this.isFullScreenSearching = false
              })

          this.fetchClientIP()
          // this.fetchDocKind()

          const vm = this
          this.socket = io.connect(getBaseURLforSocketIo())
          this.socket.on('test_event', function (data) {
             console.log('data emit from socket')
              console.log(data)
          })
          this.socket.on('user_login_event', function (data) {
              // console.log('data emit from socket')
              // console.log(data)
              if (vm.user_id === data.user_id) {
                  if (vm.fingerPrint !== data.fp) {
                      vm.$router.push('/login')

                      removeLocalStorage()
                  }
              }
          })

          this.socket.on('order_lab_new_insert', function (data) {
            //   console.log('data emit from socket')
   

              if(this.user_id){
                                vm.fetchOrdersList()
                                var datShow = 'New Order Incoming : <em>Order No.' + data.orderno + '</em> ' + '<h1>' + data.name + '  ' + data.surname + '</h1>'
                                if (data.avartar_path) {
                                    datShow = datShow + ` <figure class="image is-32x32"> <img  src="${getBaseURLAvartar()}/user_${data.iduser}/${data.avartar_path}" alt="Image" > </figure>`
                                }
                                vm.$buefy.snackbar.open({
                                    duration: 4000,
                                    // message: 'New Order Incoming.<br>Note: <em>${data.orderno}  Message can include html</em>.',
                                    message: datShow,
                                    type: 'is-danger',
                                    position: 'is-bottom-right',
                                    // actionText: 'Undo',
                                    queue: false,
                                    // onAction: () => {
                                    //     vm.$buefy.toast.open({
                                    //         message: 'Action pressed',
                                    //         queue: false
                                    //     })
                                    // }
                                })
              }  
              



          })

          this.fetchUnitCBC()
        //   this.fetchProvince() ---> move into login

          this.produceUserID(localStorage.getItem('user_id'))
          this.produceUserAvartar(localStorage.getItem('urlAvartar'))
          // find admin or not
          if (this.user_id) {
              const dat = {
                  "user_id": this.user_id
              }
              axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
              axios.post(`${getBaseURLforBackEnd()}/api/getinfouser`, dat, getConfigAxios())
                  .then((res) => {
                      vm.produceUserIsAdmin(res.data.isadmin)
                  })
             // this.fetchUserCustomizeCBCTbl(this.user_id)
          }else{
              this.$router.push('/login')
                  .catch(()=>{});
          }

    },
   data(){
      return {
          isFullScreenSearching : true
      }
    },
    watch:{
        beforeRouteUpdate (to, from, next) {
            console.log(to+from+next)
            // react to route changes...
            // don't forget to call next()
        }
    }


}
</script>

<style>
</style>
